export const iconFontAwesomeEditingWandMagicSparkles = (
	<i className="fa-solid fa-wand-magic-sparkles"></i>
);
